// extracted by mini-css-extract-plugin
export var logo = "_le-2";
export var logoWrapper = "_le-1";
export var strip = "_le-0";